import * as yup from 'yup'

export const schema = yup.object().shape({
  lessonLearned: yup.string().required(),
})

export default schema
